//LandingRouter.js
import {React, useEffect} from 'react';
import Header from '../components/Header/Header';
import SaganQuotes from '../pages/SaganQuotes/SaganQuotes';
import ScrollTest from '../pages/ScrollTest/ScrollTest';
import Company from '../pages/Company/Company';
import Vision from '../pages/Vision/Vision-A'; // A es 3 parrafos en fondo estrellado
import VisionBottom from '../pages/VisionBottom/VisionBottom-A'; // A es VisionBottom con imagen "libre"
import We from '../pages/We/We';
import Contact from '../pages/Contact/Contact';
import { t } from "@lingui/macro";


const LandingRouter = () =>
{
    const titleLine1 = t`BIENVENIDOS`;
    const titleLine2 = t`AL FUTURO`;
    const description = t`Los líderes en proyecto, construcción y operación de puertos espaciales.`;
    const button = t`CONOCER MÁS`;
        useEffect(() =>
	{
	    document.title = t`The Cosmic Shores - Construyendo los Espaciopuertos del Futuro`
    }, [titleLine1])
    return (
        <div>
            <Header titleLine1={titleLine1} titleLine2={titleLine2} description={description}/>
        {/*<div >
        <ScrollTest/>
        </div>*/}
            <div >
                <SaganQuotes />
            </div>
            <div >
                <Company />
            </div>
            <div >
                <VisionBottom />
            </div>
            <div  >
        		<We />
            </div>
              <div >
                <Vision />
            </div>
            
    	    <div >
        		<Contact />
            </div>
        </div>
    );
};

export default LandingRouter;

